module.exports = __webpack_public_path__ + "static/media/Tourist.daa65b52.jpg";